import clsx from 'clsx';
import styles from './Select.module.css';
import { useSelectController } from './lib';
import { SelectMenu } from './components/SelectMenu';
import { SelectTrigger } from './components/SelectTrigger';

export function Select({
  value,
  options,
  onChange,
  inputId,
  ariaLabel = 'Select',
  disabled = false,
  placeholder = 'Select',
  className = '',
  triggerClassName = '',
  valueClassName = '',
  chevronClassName = '',
  menuClassName = '',
  optionClassName = '',
  optionSelectedClassName = '',
  optionHighlightedClassName = '',
  optionLabelClassName = '',
  optionSpacerClassName = '',
  useActiveFieldStyle = true,
  menuPlacement = 'bottom',
  variant = 'default',
  menuWidth = 'content',
  filledBg = 'tinted',
  invalid = false,
  maxMenuRows,
}) {
  const {
    listboxId,
    rootRef,
    buttonRef,
    normalizedOptions,
    selectedLabel,
    open,
    highlightedIndex,
    setHighlightedIndex,
    commitChange,
    onTriggerKeyDown,
    onTriggerClick,
  } = useSelectController({
    value,
    options,
    onChange,
  });

  const isEmptyValue = selectedLabel.length === 0;
  const resolvedLabel = isEmptyValue ? placeholder : selectedLabel;
  const forceSurfaceBg = variant === 'form' && !isEmptyValue && filledBg === 'surface';

  const onSafeTriggerClick = disabled ? undefined : onTriggerClick;
  const onSafeTriggerKeyDown = disabled ? undefined : onTriggerKeyDown;

  return (
    <div ref={rootRef} className={clsx(styles.root, className)}>
      <SelectTrigger
        id={inputId}
        buttonRef={buttonRef}
        listboxId={listboxId}
        ariaLabel={ariaLabel}
        open={open}
        selectedLabel={resolvedLabel}
        disabled={disabled}
        triggerClassName={clsx(
          variant === 'textfield' && styles.triggerTextField,
          variant === 'form' && styles.triggerForm,
          variant === 'form' && isEmptyValue && styles.triggerFormEmpty,
          forceSurfaceBg && styles.triggerFormFilledSurface,
          triggerClassName,
        )}
        valueClassName={clsx(
          variant === 'textfield' && styles.valueTextField,
          variant === 'form' && styles.valueForm,
          variant === 'form' && isEmptyValue && styles.valuePlaceholder,
          valueClassName,
        )}
        chevronClassName={clsx(
          variant === 'textfield' && styles.chevronTextField,
          variant === 'form' && styles.chevronForm,
          chevronClassName,
        )}
        useActiveFieldStyle={useActiveFieldStyle}
        invalid={invalid}
        onClick={onSafeTriggerClick}
        onKeyDown={onSafeTriggerKeyDown}
      />

      {open && !disabled ? (
        <SelectMenu
          listboxId={listboxId}
          ariaLabel={ariaLabel}
          menuPlacement={menuPlacement}
          menuClassName={clsx(menuWidth === 'field' && styles.menuFieldWidth, menuClassName)}
          optionClassName={optionClassName}
          optionSelectedClassName={optionSelectedClassName}
          optionHighlightedClassName={optionHighlightedClassName}
          optionLabelClassName={optionLabelClassName}
          optionSpacerClassName={optionSpacerClassName}
          options={normalizedOptions}
          value={value}
          highlightedIndex={highlightedIndex}
          setHighlightedIndex={setHighlightedIndex}
          commitChange={commitChange}
          maxMenuRows={maxMenuRows}
        />
      ) : null}
    </div>
  );
}
